import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/business";
import { useSettings, useFooterPages } from "@/lib/brands";

export default function Footer() {
  const { data: settings } = useSettings();
  const { data: footerPages = [] } = useFooterPages();
  const biz = settings?.business || BUSINESS;

  return (
    <footer className="border-t border-hair" data-testid="site-footer">
      <div className="mx-auto max-w-desk px-5 py-12 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[2fr_1fr_1fr_1fr]">
          <div>
            <div className="font-serif text-lg font-semibold text-ink">{biz.name}</div>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-muted">
              {biz.footer_blurb || BUSINESS.footer_blurb}
            </p>
          </div>
          <div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-muted">
              Categories
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/category/retail" className="text-ink hover:text-accent">Retail</Link></li>
              <li><Link to="/category/crypto" className="text-ink hover:text-accent">Crypto</Link></li>
              <li><Link to="/category/social" className="text-ink hover:text-accent">Social Media</Link></li>
              <li><Link to="/category/email" className="text-ink hover:text-accent">Email Providers</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-muted">Company</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/how-it-works" className="text-ink hover:text-accent">How It Works</Link></li>
              <li><Link to="/about" className="text-ink hover:text-accent">About</Link></li>
              <li><Link to="/contact" className="text-ink hover:text-accent">Contact</Link></li>
              {footerPages.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={p.system ? `/${p.slug}` : `/p/${p.slug}`}
                    data-testid={`footer-page-${p.slug}`}
                    className="text-ink hover:text-accent"
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-mono text-[11px] uppercase tracking-widest text-muted">Legal</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/privacy" data-testid="footer-privacy" className="text-ink hover:text-accent">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-terms" className="text-ink hover:text-accent">Terms of Service</Link></li>
              <li><Link to="/refunds" data-testid="footer-refunds" className="text-ink hover:text-accent">Refund Policy</Link></li>
              <li><Link to="/disclaimer" data-testid="footer-disclaimer" className="text-ink hover:text-accent">Disclaimer</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-hair pt-6">
          <p className="font-mono text-[11px] leading-relaxed tracking-wide text-muted">
            DISCLAIMER: It&apos;s Genie Assist is an independent customer service directory. We are
            NOT affiliated with, endorsed by, or connected to any brand listed. All brand names and
            trademarks are the property of their respective owners. Phone numbers and links are
            sourced from official brand websites and shown with the date we last verified them.
          </p>
          <p className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted" data-testid="business-identity">
            <span className="font-medium text-ink">{biz.name}</span>
            <span aria-hidden>·</span>
            <span>{biz.address}, {biz.location}</span>
            <span aria-hidden>·</span>
            <a href={`mailto:${biz.email}`} className="text-accent hover:underline">{biz.email}</a>
          </p>
          <p className="mt-2 text-xs text-muted">
            © {new Date().getFullYear()} {biz.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
